import React from 'react';
import { observer } from 'mobx-react-lite';
import ItemPage from 'pages/ItemPage';
import EditPortal from 'pages/EditPortal';
import PortalDeleteDialog from 'components/deletion/PortalDeleteDialog';
import { PortalDeletionStatusFormatter } from 'components/deletion/tenantDeletionLabels';
import {
  clonePortalAction,
  deployPortalAction,
  viewPortalAction,
} from 'components/deletion/portalListActions';
import { usePortalDeletion } from 'components/deletion/usePortalDeletion';

const PortalItemPage = observer(() => {
  const {
    deletionActions,
    deleteFlow,
    setDeleteFlow,
    handleDeletePortal,
  } = usePortalDeletion();

  return (
    <>
      <ItemPage
        modelName="portal"
        EditScreen={EditPortal}
        hideDefaultDelete
        secondaryFields={[
          { name: 'status', label: 'Status', formatter: PortalDeletionStatusFormatter },
        ]}
        additionalActions={[
          viewPortalAction,
          deployPortalAction,
          clonePortalAction,
          ...deletionActions,
        ]}
      />
      {deleteFlow && (
        <PortalDeleteDialog
          open
          portalName={deleteFlow.portal.name}
          loading={deleteFlow.loading}
          loadError={deleteFlow.loadError}
          previewData={deleteFlow.previewData}
          onClose={() => setDeleteFlow(null)}
          onConfirm={handleDeletePortal}
        />
      )}
    </>
  );
});

export default PortalItemPage;
